(function () {
  'use strict';

  angular
      .module('tfc.retailer.Consumer')
      .factory('ConsumerProfileReport', ConsumerProfileReport);

  // @ngInject
  function ConsumerProfileReport($q, util, Upload, ExcelReportType, GaUtil, Api){

    return {
      downloadReport : downloadReport
    };

    function getFileContent(type, selectedBrandKey, selectedGender, selectedHeightUnit, selectedWeightUnit, selectedInseamUnit, selectedFootLengthUnit, selectedBustSizeUnit, region, transaction, isActivityExist, isRegionExist) {
      return $q.when(content(type, selectedBrandKey, selectedGender, selectedHeightUnit, selectedWeightUnit, selectedInseamUnit, selectedFootLengthUnit, selectedBustSizeUnit, region, transaction, isActivityExist, isRegionExist))
      .then(function (content) {
        return content;
      });
    }

    function generateURL(type) {
      return '/consumer/' + type;
    }

    function content(type, selectedBrandKey, selectedGender, selectedHeightUnit, selectedWeightUnit, selectedInseamUnit, selectedFootLengthUnit, selectedBustSizeUnit, region, transaction, isActivityExist, isRegionExist) {

      var ageUnitValue = 'years';

      return Api.get(generateURL(type + 'Report'), {
        cache : false,
        params: {
          brandKey: selectedBrandKey,
          gender: selectedGender,
          ageUnit: ageUnitValue,
          weightUnit: selectedWeightUnit,
          heightUnit: selectedHeightUnit,
          inseamUnit: selectedInseamUnit,
          footLengthUnit: selectedFootLengthUnit,
          bustSizeUnit: selectedBustSizeUnit,
          region: region,
          transaction: transaction,
          isActivityExist: isActivityExist,
          isRegionExist: isRegionExist
        },
        responseType : 'arraybuffer',
        headers: {
          'Accept': ExcelReportType
        }
      }).then(function (response) {
        var disposition = util.parseMultipartHeader(response.headers('content-disposition'));
          return $q.all({
            fileName: disposition.filename,
            dataBlob: new Blob([response.data], { type : disposition['content-type'] })
          });
        });
    }

    function downloadReport(type, selectedBrandKey, selectedGender, selectedHeightUnit, selectedWeightUnit, selectedInseamUnit, selectedFootLengthUnit, selectedBustSizeUnit, region, transaction, isActivityExist, isRegionExist) {
      return getFileContent(type, selectedBrandKey, selectedGender, selectedHeightUnit, selectedWeightUnit, selectedInseamUnit, selectedFootLengthUnit, selectedBustSizeUnit, region, transaction, isActivityExist, isRegionExist)
      .then(function (content) {
        download(content.dataBlob, content.fileName, ExcelReportType);
        GaUtil.sendGaEvent(selectedBrandKey, 'Download Report', 'Demographic & Body Shape Report');
      });
    }
  }

})();
